import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="role-toggle"
export default class extends Controller {
  static targets = ["radio", "clubAssignment", "label", "circle", "innerDot"]
  static values = { 
    selectedRole: String,
    managerBorderClass: String,
    fanBorderClass: String,
    activeBorderClass: String,
    activeBackgroundClass: String,
    inactiveBorderClass: String,
    activeCircleClass: String,
    inactiveCircleClass: String
  }

  connect() {
    console.log("🎯 Role toggle controller connected")
    console.log("Radio targets found:", this.radioTargets.length)
    console.log("Current selected role value:", this.selectedRoleValue)
    
    // Detect currently selected role from DOM
    const checkedRadio = this.radioTargets.find(radio => radio.checked)
    if (checkedRadio) {
      console.log("Found checked radio:", checkedRadio.value)
      this.selectedRoleValue = checkedRadio.value
    } else {
      console.log("No radio is checked, defaulting to fan")
      this.selectedRoleValue = 'fan'
    }
    
    console.log("Final selected role:", this.selectedRoleValue)
    this.updateUI()
  }

  disconnect() {
    console.log("Role toggle controller disconnected")
  }

  // Called when any radio button changes
  roleChanged(event) {
    console.log("🔄 Role changed to:", event.target.value)
    this.selectedRoleValue = event.target.value
    this.updateUI()
  }

  // Stimulus action - called automatically when radio changes
  radioChanged(event) {
    this.roleChanged(event)
  }

  updateUI() {
    this.updateClubAssignmentVisibility()
    this.updateRadioStyling()
  }

  updateClubAssignmentVisibility() {
    console.log("🏢 Updating club assignment visibility")
    console.log("Has club assignment target:", this.hasClubAssignmentTarget)
    console.log("Selected role:", this.selectedRoleValue)
    
    if (this.hasClubAssignmentTarget) {
      if (this.selectedRoleValue === 'manager') {
        console.log("Showing club assignment")
        this.clubAssignmentTarget.style.display = 'block'
      } else {
        console.log("Hiding club assignment")
        this.clubAssignmentTarget.style.display = 'none'
      }
    } else {
      console.log("No club assignment target found")
    }
  }

  updateRadioStyling() {
    console.log("🎨 Updating radio styling")
    console.log("Label targets:", this.labelTargets.length)
    console.log("Circle targets:", this.circleTargets.length)
    console.log("Inner dot targets:", this.innerDotTargets.length)
    
    this.radioTargets.forEach((radio, index) => {
      const label = this.labelTargets[index]
      const circle = this.circleTargets[index]
      const innerDot = this.innerDotTargets[index]

      console.log(`Radio ${index}: checked=${radio.checked}, value=${radio.value}`)

      if (radio.checked) {
        // Active state
        console.log(`Setting active styles for ${radio.value}`)
        this.setActiveStyles(label, circle, innerDot)
      } else {
        // Inactive state
        console.log(`Setting inactive styles for ${radio.value}`)
        this.setInactiveStyles(label, circle, innerDot)
      }
    })
  }

  setActiveStyles(label, circle, innerDot) {
    // Remove inactive classes and add active classes
    label.classList.remove('border-gray-300', 'hover:border-gray-400')
    label.classList.add('border-indigo-500', 'bg-indigo-50')
    
    circle.classList.remove('border-gray-300')
    circle.classList.add('border-indigo-500', 'bg-indigo-500')
    
    if (innerDot) {
      innerDot.style.display = 'block'
    }
  }

  setInactiveStyles(label, circle, innerDot) {
    // Remove active classes and add inactive classes
    label.classList.remove('border-indigo-500', 'bg-indigo-50')
    label.classList.add('border-gray-300', 'hover:border-gray-400')
    
    circle.classList.remove('border-indigo-500', 'bg-indigo-500')
    circle.classList.add('border-gray-300')
    
    if (innerDot) {
      innerDot.style.display = 'none'
    }
  }

  // Public method to set role programmatically
  setRole(role) {
    const targetRadio = this.radioTargets.find(radio => radio.value === role)
    if (targetRadio) {
      targetRadio.checked = true
      this.selectedRoleValue = role
      this.updateUI()
    }
  }

  // Get currently selected role
  getSelectedRole() {
    const checkedRadio = this.radioTargets.find(radio => radio.checked)
    return checkedRadio ? checkedRadio.value : null
  }
}